import React from 'react';

function Chevron(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M5.52543 9.59332C5.32328 9.82921 5.32769 10.1724 5.52166 10.4024L5.59332 10.4746L11.3098 15.3734C11.6671 15.6806 12.2003 15.7065 12.5872 15.4512L12.6891 15.3743L18.4067 10.4746C18.6688 10.25 18.6992 9.85542 18.4746 9.59332C18.2724 9.35743 17.9326 9.30922 17.6756 9.46568L17.5933 9.52543L11.999 14.317L6.40671 9.52543C6.17081 9.32328 5.82763 9.32769 5.59761 9.52166L5.52543 9.59332Z" />
    </svg>
  );
}

export default Chevron;
